require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-facebook-ifttt-test.json") })
        }
      }, "path---post-facebook-ifttt-test");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-facebook-ifttt-test!./.cache/json/post-facebook-ifttt-test.json
// module id = 323
// module chunks = 231608221292675